import { FC } from 'react';
import { Button as AntdButton, ButtonProps as AntButtonProps } from 'antd';

export type ButtonProps = Omit<AntButtonProps, 'type'> & {
  type?: AntButtonProps['type'] | 'secondary';
};

export const Button: FC<ButtonProps> = ({ type = 'primary', size = 'large', ...props }) => {
  const buttonProps = { size, ...props };

  return (
    <AntdButton
      {...buttonProps}
      type={type as AntButtonProps['type']}
      onClick={(...args) => {
        props.onClick?.(...args);
      }}
    />
  );
};
